import { WarningOutlined } from '@ant-design/icons';
import { Modal, ModalProps, Typography } from 'antd';

interface ConfirmHireCandidateModalProps extends ModalProps {
  remainingPositions: number;
  jobPostingName: string;
  candidateName: string;
  onSuccess?: () => void | Promise<unknown>;
}

const ConfirmHireCandidateModal = ({
  remainingPositions,
  jobPostingName,
  candidateName,
  ...props
}: ConfirmHireCandidateModalProps) => {
  return (
    <Modal
      okButtonProps={{
        htmlType: 'submit',
      }}
      okText={remainingPositions < 1 ? 'Ok' : 'Contratar e concluir vaga'}
      title={
        remainingPositions < 1 ? (
          <Typography.Text strong>
            <WarningOutlined /> Atenção! Esta ação não poderá ser realizada
          </Typography.Text>
        ) : (
          <Typography.Text strong>
            <WarningOutlined /> Atenção! Esta vaga será concluída automaticamente
          </Typography.Text>
        )
      }
      {...props}
    >
      {remainingPositions < 1 ? (
        <Typography.Paragraph>
          Esta vaga possui {remainingPositions} posições restantes e a quantidade de candidatos
          selecionados irá ultrapassar o limite de contratações permitidas para a vaga. Revisite os
          candidatos selecionados ou a quantidade de posições da vaga.
        </Typography.Paragraph>
      ) : (
        <>
          <Typography.Paragraph>
            Ao realizar esta movimentação, você preencherá todas as posições e esta vaga será
            concluída automaticamente.
          </Typography.Paragraph>
          <Typography.Paragraph>
            Essa ação <Typography.Text strong>não poderá ser desfeita</Typography.Text>, tem certeza
            que deseja contratar o(a) candidato(a){' '}
            <Typography.Text strong>{candidateName}</Typography.Text> e concluir a vaga{' '}
            {jobPostingName}?
          </Typography.Paragraph>
        </>
      )}
    </Modal>
  );
};

export default ConfirmHireCandidateModal;
